import { schedularTherapistFilterAction } from 'src/redux/actions/constant';


const intialState: object = {
  response: null,
  getSplitTask: false,
  loading: false,
};

export const getSplitTaskReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.GET_SPLIT_TASK_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        getSplitTask: true,
        loading: false,
      };
    }
    case  schedularTherapistFilterAction.GET_SPLIT_TASK_FAILURE : {
      return {
        ...state,
        response: action.payload,
        getSplitTask: false,
        loading: false,
      };
    }

    case schedularTherapistFilterAction.GET_SPLIT_TASK_LOADING:
      return {
        ...state,
        loading: true,
      };

    case schedularTherapistFilterAction.GET_SPLIT_TASK_RESET:
      return intialState   


    default:
      return state;
  }
};
